import './RegPage.css';
import useInputString from '../../hooks/useInputString';
import { useState } from 'react';
import { EyeFill, EyeSlashFill, XLg } from 'react-bootstrap-icons';
import { IUserSignUpRequestModel } from '../../interfaces/requests/IUserSignUpRequestModel';
import { signup } from '../../http/userAPI';
import { useNavigate } from 'react-router-dom';
import FromAlert from "../../components/Forms/FromAlert";
import ClassicButton from "../../components/UI/ClassicButton/ClassicButton";
import useScreenWidth from "../../hooks/useScreenWidth";

const RegPage: React.FC = () => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(false)
    const firstname = useInputString('');
    const middlename = useInputString('');
    const lastname = useInputString('');
    const phone = useInputString('');
    const email = useInputString('');
    const password = useInputString('');
    const confirmPassword = useInputString('');
    const [passwordShown1, setPasswordShown1] = useState<boolean>(false);
    const [passwordShown2, setPasswordShown2] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>();
    const [isAlertVisible, setAlertVisible] = useState<boolean>();
    const [errorFields, setErrorFields] = useState<string[]>([]);
    const [agreement, setAgreement] = useState<boolean>(false);
    const screenWidth = useScreenWidth();

    const togglePasswordVisibility1 = () => {
        setPasswordShown1(!passwordShown1);
    };

    const togglePasswordVisibility2 = () => {
        setPasswordShown2(!passwordShown2);
    };

    const closeAlert = () => {
        setAlertVisible(false);
    };

    const handleReg = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        const missingFields: string[] = [];
        if (!firstname.value) missingFields.push('firstname');
        if (!lastname.value) missingFields.push('lastname');
        if (!phone.value) missingFields.push('phone');
        if (!email.value) missingFields.push('email');
        if (!password.value) missingFields.push('password');
        if (!confirmPassword.value) missingFields.push('confirmPassword');

        if (missingFields.length > 0) {
            setAlertMessage('Заполните все обязательные поля для регистрации.');
            setAlertVisible(true);
            setErrorFields(missingFields);
            setLoading(false);
            return;
        }

        if (password.value !== confirmPassword.value) {
            setAlertMessage('Пароли не совпадают.');
            setAlertVisible(true);
            setLoading(false);
            return;
        }

        if (!agreement) {
            setAlertMessage('Ознакомьтесь с пользовательским соглашением.');
            setAlertVisible(true);
            setLoading(false);
            return;
        }

        const userData: IUserSignUpRequestModel = {
            email: email.value,
            password: password.value,
            phone: phone.value,
            firstname: firstname.value,
            lastname: lastname.value,
            middlename: middlename.value || null
        };

        signup(userData)
            .then((response) => {
                if (response?.error) {
                    setAlertMessage(response.error);
                    setAlertVisible(true);
                } else {
                    setAlertMessage('Успешная регистрация! Проверьте вашу электронную почту для подтверждения.');
                    setAlertVisible(true);

                    email.reset();
                    password.reset();
                    confirmPassword.reset();
                    phone.reset();
                    firstname.reset();
                    lastname.reset();
                    middlename.reset();
                }
            })
            .catch(() => {
                setAlertMessage('Произошла ошибка при регистрации. Попробуйте позже.');
                setAlertVisible(true);
            })
            .finally(() => {
                setLoading(false);
                setErrorFields([]);
                navigate('/');
            });
    };

    return (
        <div className='form_container regPage'>
            <h2>Регистрация</h2>
            <form className="form">

                <div className={`form_inputContainer`}>
                    {isAlertVisible && (
                        <FromAlert onClose={closeAlert}>
                            {alertMessage}
                        </FromAlert>
                    )}

                    <p>Имя</p>
                    <input
                        className={`firstname ${errorFields.includes('firstname') ? 'error' : ''}`}
                        type="text"
                        value={firstname.value}
                        onChange={firstname.onChange}
                        autoCapitalize='name'
                    />
                </div>

                <div className={`form_inputContainer`}>
                    <p>Фамилия</p>
                    <input
                        className={`lastname ${errorFields.includes('lastname') ? 'error' : ''}`}
                        type="text"
                        value={lastname.value}
                        onChange={lastname.onChange}
                        autoCapitalize='surname'
                    />
                </div>

                <div className='form_inputContainer'>
                    <p>Отчество (при наличии)</p>
                    <input
                        className="midlname"
                        type="text"
                        value={middlename.value}
                        onChange={middlename.onChange}
                        autoCapitalize='midlname'
                    />
                </div>

                <div className={`form_inputContainer`}>
                    <p>Почта</p>
                    <input
                        className={`email ${errorFields.includes('email') ? 'error' : ''}`}
                        type="email"
                        value={email.value}
                        onChange={email.onChange}
                        autoComplete="email"
                    />
                </div>

                <div className={`form_inputContainer`}>
                    <p>Номер телефона</p>
                    <input
                        className={`email ${errorFields.includes('phone') ? 'error' : ''}`}
                        type="tel"
                        value={phone.value}
                        onChange={phone.onChange}
                        autoCapitalize='phone'
                    />
                </div>

                <div className={`form_inputContainer`}>
                    <p>Пароль</p>
                    <div className='input_passwordWrapper'>
                        <input
                            className={`password ${passwordShown1 ? '' : 'active'} ${errorFields.includes('password') ? 'error' : ''}`}
                            type={passwordShown1 ? "text" : "password"}
                            value={password.value}
                            onChange={password.onChange}
                            autoComplete="new-password"
                        />
                        <div className="toggle_password" onClick={togglePasswordVisibility1}>
                            {passwordShown1 ? <EyeSlashFill /> : <EyeFill />}
                        </div>
                    </div>
                </div>

                <div className='form_inputContainer'>
                    <p>Подтверждение пароля</p>
                    <div className={`input_passwordWrapper`}>
                        <input
                            className={`password ${passwordShown2 ? '' : 'active'} ${errorFields.includes('confirmPassword') ? 'error' : ''}`}
                            type={passwordShown2 ? "text" : "password"}
                            value={confirmPassword.value}
                            onChange={confirmPassword.onChange}
                            autoComplete="new-password"
                        />
                        <div className="toggle_password" onClick={togglePasswordVisibility2}>
                            {passwordShown2 ? <EyeSlashFill /> : <EyeFill />}
                        </div>
                    </div>
                </div>

                <div className='form_inputContainer_agreement'>
                    <input type="checkbox" onChange={(e) => setAgreement(e.target.checked)} />
                    <p>
                        Я принимаю условия <span className='agreementLink' onClick={() => {
                        window.open('/user-agreement', '_blank');
                    }}>Пользовательского соглашения</span> и даю своё согласие Miart на обработку моей персональной информации на условиях, определенных <span className='agreementLink' onClick={() => {
                        window.open('/privacy-policy', '_blank');
                    }}>Политикой конфиденциальности</span>.
                    </p>
                </div>

                <ClassicButton
                    isLoading={isLoading}
                    onClick={handleReg}
                    width={screenWidth <= 1000 ? '70%' : '30%'}
                    height='40px'
                    innerLoaderSize='20px'
                    fontSize=''
                    fontFamily='Actay Regular'
                    fontColor='#754737FF'
                    bgColor='#FFE5CCFF'
                >
                    Регистрация
                </ClassicButton>
            </form>
        </div>
    );
}

export default RegPage;